/* Fixed legacy room image; keep language and links synchronized. */
(() => {
  'use strict';
  if (window.klikRoomInspirationInstalled) return;
  window.klikRoomInspirationInstalled = true;
  function localize(scope) {
    const ar = /^ar(?:-|$)/i.test(document.documentElement.lang);
    scope.querySelectorAll('[data-klik-i18n-en][data-klik-i18n-ar]').forEach(node => {
      node.textContent = ar ? node.dataset.klikI18nAr : node.dataset.klikI18nEn;
    });
    scope.querySelectorAll('[data-room-alt-en]').forEach(node => {
      node.alt = ar ? node.dataset.roomAltAr : node.dataset.roomAltEn;
    });
    scope.querySelectorAll('a[href]').forEach(link => {
      if (window.KlikStorefrontURL) link.href = window.KlikStorefrontURL(link.getAttribute('href'));
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-klik-room-inspiration]').forEach(localize);
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  new MutationObserver(() => initialize()).observe(document.documentElement, {attributes: true, attributeFilter: ['lang']});
})();
